/* eslint-disable custom/no-restricted-translation-jsx-untranslated-children-text */
import React from 'react';

import { Typography } from '@mui/material';

import { useIntl } from '@kamernet/core/Intl';
import { Locale } from '@kamernet/core/Intl/types';

import styles from './Content.module.css';

interface ContentStreetFurnishedApartmentsProps {
  streetName: string;
  cityName: string;
}

export const ContentStreetFurnishedApartments = ({
  streetName,
  cityName,
}: ContentStreetFurnishedApartmentsProps) => {
  const { locale } = useIntl();

  return locale === Locale.en ? (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Furnished Apartments for Rent in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Looking for furnished apartments in ${streetName}? Kamernet will help you
        find furnished apartments for rent in ${streetName} that match your
        needs and budget. Choose from fully furnished rentals in ${streetName}
        with flexible leases starting from one month. Whether you need
        short-term and long-term furnished apartments in ${streetName} or just a
        simple, ready-to-move space, you’ll find options that fit your plans.
        Each listing includes fully furnished properties in ${streetName} with
        appliances, internet, and utilities set up. From student stays to
        corporate housing, ${streetName} furnished apartments offer comfort and
        convenience. Start your search today and find fully furnished apartments
        in ${streetName} without delays or added fees.`}
      </Typography>
    </React.Fragment>
  ) : (
    <React.Fragment>
      <Typography variant="h1" className={styles.title}>
        {`Gemeubileerde Appartementen te Huur in ${streetName}, ${cityName}`}
      </Typography>
      <Typography variant="body1" className={styles.paragraph}>
        {`Ben je op zoek naar een gemeubileerd appartement in ${streetName}?
        Gebruik de slimme filters om eenvoudig een woning te vinden die past bij
        jouw wensen en budget. Kies uit volledig gemeubileerde appartementen in
        ${streetName} met flexibele huurperiodes vanaf één maand. Of je nu een
        kort verblijf plant, langer blijft, of gewoon een instapklare woning
        zoekt, in ${streetName} vind je altijd opties die bij jouw situatie
        passen. Elke woning is volledig gemeubileerd en voorzien van apparatuur,
        internet en werkende nutsvoorzieningen.. Van studentenverblijf tot
        zakelijke huisvesting, gemeubileerde appartementen in ${streetName}
        bieden comfort en gemak. Start vandaag nog je zoektocht en vind een
        volledig gemeubileerd appartement in ${streetName}, zonder wachttijd of
        extra kosten.`}
      </Typography>
    </React.Fragment>
  );
};
